/**
 * Keep in sync with repo root config/mongoCollections.js (CRA cannot import outside src).
 */
export const COLLECTION = {
    users: 'users',
    abilityQuestionBank: 'ability_question_bank',
    abilityTestSubmissions: 'ability_test_submissions',
    abilityTestProgress: 'ability_test_progress',
    interestQuestionBank: 'interest_question_bank',
    interestTestSubmissions: 'interest_test_submissions',
    interestTestProgress: 'interest_test_progress',
    // Legacy alias kept for compatibility with older modules.
    interestTestRecords: 'interest_test_submissions',
    eddyChatSessions: 'eddy_chat_sessions',
    usageAnalytics: 'analytics_usage',
    pressReleases: 'press_releases',
    careerPostings: 'career_postings',
    interestQuestionnaireMap: 'interest_questionnaire_map',
    interestClusterProfiles: 'interest_cluster_profiles',
    interestKeywordCorrelation: 'interest_keyword_correlation',
    kbDocuments: 'kb_documents',
    kbChunks: 'kb_chunks',
    hkuArtsUsage: 'hku_arts_usage'
};
